/* eslint-disable no-param-reassign */
/* eslint-disable react/destructuring-assignment */

import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { DerivedDataObject } from 'react-table';
import * as xlsx from 'xlsx';

import Button from '../buttons/button';

export interface ExportTableOwnProps {
  getData: () => DerivedDataObject[];
  tableName?: string;
}

const SHEET_NAME = 'Sheet 1';

export class XlsxTableExporter<OwnProps extends ExportTableOwnProps = ExportTableOwnProps> extends React.Component<
  OwnProps
> {
  constructor(props: any) {
    super(props);
    this.saveFile = this.saveFile.bind(this);
  }

  protected saveFile() {
    const { getData, tableName } = this.props;

    const tableData = getData();
    const wb = this.generateWorkbook(tableData);
    xlsx.writeFile(wb, tableName ? `${tableName}.xlsx` : 'table.xlsx');
  }

  private scrubData(data: DerivedDataObject[]) {
    return data.map(({ _nestingLevel, _original, _index, ...row }) => row);
  }

  private generateWorkbook(data: any): xlsx.WorkBook {
    const wb = xlsx.utils.book_new();
    const ws = xlsx.utils.json_to_sheet(this.scrubData(data));
    wb.SheetNames.push(SHEET_NAME);
    wb.Sheets[SHEET_NAME] = ws;

    return wb;
  }

  public render() {
    return <Button onClick={this.saveFile} text="Export to Excel" allCapitals inverseColours icon={faFileExcel} />;
  }
}
